<template>
  <section class="bloc-age-gate">
    <div class="bloc-age-gate__bg">
      <PlayerAutoVideoEmbed :content="video" />
    </div>
    <div class="bloc-age-gate__popin">
      <form class="form" action="#" @submit.prevent="onSubmit">
        <img class="logo" svg-inline src="@/assets/images/icons/logo-krug.svg" />

        <span class="main-info">To visit our site, you must be of legal age.</span>

        <select id="agegate-country" name="country" class="form-select-country" ref="select_country" @change="onCountryChange">
          <option value="gb" selected="selected">United Kingdom</option>
          <option value="fr">France</option>
          <option value="it">Italy</option>
          <option value="jp">Japan</option>
          <option value="us">USA</option>
          <option value="de">Allemagne</option>
          <option value="ko">South Korea</option>
          <option value="af">Afghanistan</option>
          <option value="al">Albania</option>
          <option value="dz">Algeria</option>
          <option value="ad">Andorra</option>
          <option value="ao">Angola</option>
          <option value="ag">Antigua and Barbuda</option>
          <option value="ar">Argentina</option>
          <option value="am">Armenia</option>
          <option value="au">Australia</option>
          <option value="at">Austria</option>
          <option value="az">Azerbaidjan</option>
          <option value="bs">Bahamas</option>
          <option value="bh">Bahrain</option>
          <option value="bd">Bangladesh</option>
          <option value="bb">Barbados</option>
          <option value="by">Belarus</option>
          <option value="be">Belgium</option>
          <option value="bz">Belize</option>
          <option value="bj">Benin</option>
          <option value="bt">Bhutan</option>
          <option value="bo">Bolivia</option>
          <option value="ba">Bosnia and Herzegovina</option>
          <option value="bw">Botswana</option>
          <option value="br">Brazil</option>
          <option value="bn">Brunei Darussalam</option>
          <option value="bg">Bulgaria</option>
          <option value="bf">Burkina Faso</option>
          <option value="bi">Burundi</option>
          <option value="kh">Cambodia</option>
          <option value="cm">Cameroon</option>
          <option value="ca">Canada</option>
          <option value="cv">Cape Verde</option>
          <option value="cf">Central African Republic</option>
          <option value="td">Chad</option>
          <option value="cl">Chile</option>
          <option value="cn">China Mainland</option>
          <option value="co">Colombia</option>
          <option value="km">Comoros</option>
          <option value="cr">Costa Rica</option>
          <option value="hr">Croatia</option>
          <option value="cu">Cuba</option>
          <option value="cy">Cyprus</option>
          <option value="cz">Czech Republic</option>
          <option value="dk">Denmark</option>
          <option value="dj">Djibouti</option>
          <option value="dm">Dominica</option>
          <option value="do">Dominican Republic</option>
          <option value="cg">DR Congo</option>
          <option value="tl">East Timor</option>
          <option value="ec">Ecuador</option>
          <option value="eg">Egypt</option>
          <option value="sv">El Salvador</option>
          <option value="gq">Equatorial Guinea</option>
          <option value="er">Eritrea</option>
          <option value="ee">Estonia</option>
          <option value="et">Ethiopia</option>
          <option value="fj">Fiji</option>
          <option value="fi">Finland</option>
          <option value="fr">France</option>
          <option value="ga">Gabon</option>
          <option value="gm">Gambia</option>
          <option value="de">Allemagne</option>
          <option value="gh">Ghana</option>
          <option value="gr">Greece</option>
          <option value="gd">Grenada</option>
          <option value="gt">Guatemala</option>
          <option value="gn">Guinea</option>
          <option value="gw">Guinea-Bissau</option>
          <option value="gy">Guyana</option>
          <option value="ht">Haiti</option>
          <option value="hn">Honduras</option>
          <option value="hk">Hong Kong S.A.R</option>
          <option value="hu">Hungary</option>
          <option value="is">Iceland</option>
          <option value="in">India</option>
          <option value="id">Indonesia</option>
          <option value="ir">Iran</option>
          <option value="iq">Iraq</option>
          <option value="ie">Ireland</option>
          <option value="il">Israel</option>
          <option value="it">Italy</option>
          <option value="ci">Ivory Coast</option>
          <option value="jm">Jamaica</option>
          <option value="jp">Japan</option>
          <option value="jo">Jordan</option>
          <option value="kz">Kazakhstan</option>
          <option value="ke">Kenya</option>
          <option value="ki">Kiribati</option>
          <option value="kw">Kuwait</option>
          <option value="kg">Kyrgyzstan</option>
          <option value="la">Lao PDR</option>
          <option value="lv">Latvia</option>
          <option value="lb">Lebanon</option>
          <option value="ls">Lesotho</option>
          <option value="lr">Liberia</option>
          <option value="ly">Libya</option>
          <option value="li">Liechtenstein</option>
          <option value="lt">Lithuania</option>
          <option value="lu">Luxembourg</option>
          <option value="mo">Macao S.A.R</option>
          <option value="mk">Macedonia</option>
          <option value="mg">Madagascar</option>
          <option value="mw">Malawi</option>
          <option value="my">Malaysia</option>
          <option value="mv">Maldives</option>
          <option value="ml">Mali</option>
          <option value="mt">Malta</option>
          <option value="mh">Marshall Islands</option>
          <option value="mr">Mauritania</option>
          <option value="mu">Mauritius</option>
          <option value="mx">Mexico</option>
          <option value="fm">Micronesia</option>
          <option value="md">Moldova</option>
          <option value="mc">Monaco</option>
          <option value="mn">Mongolia</option>
          <option value="me">Montenegro</option>
          <option value="ma">Morocco</option>
          <option value="mz">Mozambique</option>
          <option value="mm">Myanmar</option>
          <option value="na">Namibia</option>
          <option value="nr">Nauru</option>
          <option value="np">Nepal</option>
          <option value="nl">Netherlands</option>
          <option value="nz">New Zealand</option>
          <option value="ni">Nicaragua</option>
          <option value="ne">Niger</option>
          <option value="ng">Nigeria</option>
          <option value="kp">North Korea</option>
          <option value="no">Norway</option>
          <option value="om">Oman</option>
          <option value="pk">Pakistan</option>
          <option value="pw">Palau</option>
          <option value="pa">Panama</option>
          <option value="pg">Papua New Guinea</option>
          <option value="py">Paraguay</option>
          <option value="pe">Peru</option>
          <option value="ph">Philippines</option>
          <option value="pl">Poland</option>
          <option value="pt">Portugal</option>
          <option value="qa">Qatar</option>
          <option value="ro">Romania</option>
          <option value="ru">Russia</option>
          <option value="rw">Rwanda</option>
          <option value="kn">Saint Kitts and Nevis</option>
          <option value="lc">Saint Lucia</option>
          <option value="vc">Saint Vincent &amp; the Grenadines</option>
          <option value="ws">Samoa</option>
          <option value="sm">San Marino</option>
          <option value="st">Sao Tome and Principe</option>
          <option value="sa">Saudi Arabia</option>
          <option value="sn">Senegal</option>
          <option value="rs">Serbia</option>
          <option value="sc">Seychelles</option>
          <option value="sl">Sierra Leone</option>
          <option value="sg">Singapore</option>
          <option value="sk">Slovakia</option>
          <option value="si">Slovenia</option>
          <option value="sb">Solomon Islands</option>
          <option value="so">Somalia</option>
          <option value="za">South Africa</option>
          <option value="kr">South Korea</option>
          <option value="es">Spain</option>
          <option value="lk">Sri Lanka</option>
          <option value="sd">Sudan</option>
          <option value="sr">Suriname</option>
          <option value="sz">Swaziland</option>
          <option value="se">Sweden</option>
          <option value="ch">Switzerland</option>
          <option value="sy">Syria</option>
          <option value="tw">Taiwan Region</option>
          <option value="tj">Tajikistan</option>
          <option value="tz">Tanzania</option>
          <option value="th">Thailand</option>
          <option value="tg">Togo</option>
          <option value="to">Tonga</option>
          <option value="tt">Trinidad and Tobago</option>
          <option value="tn">Tunisia</option>
          <option value="tr">Turkey</option>
          <option value="tm">Turkmenistan</option>
          <option value="tv">Tuvalu</option>
          <option value="ug">Uganda</option>
          <option value="ua">Ukraine</option>
          <option value="ae">United Arab Emirates</option>
          <option value="gb">United Kingdom</option>
          <option value="uy">Uruguay</option>
          <option value="us">USA</option>
          <option value="uz">Uzbekistan</option>
          <option value="vu">Vanuatu</option>
          <option value="ve">Venezuela</option>
          <option value="vn">Vietnam</option>
          <option value="ye">Yemen</option>
          <option value="zm">Zambia</option>
          <option value="zw">Zimbabwe</option>
        </select>

        <div class="selects-date">
          <select v-show="checkLevel >= 3" class="form-select-day" title="Day" name="date[day]" ref="select_day" @change="onDateChange">
            <option value="">Day</option>
            <option value="1" selected="selected">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
            <option value="17">17</option>
            <option value="18">18</option>
            <option value="19">19</option>
            <option value="20">20</option>
            <option value="21">21</option>
            <option value="22">22</option>
            <option value="23">23</option>
            <option value="24">24</option>
            <option value="25">25</option>
            <option value="26">26</option>
            <option value="27">27</option>
            <option value="28">28</option>
            <option value="29">29</option>
            <option value="30">30</option>
            <option value="31">31</option>
          </select>
          
          <select v-show="checkLevel >= 2" class="form-select-month" data-drupal-selector="edit-date-month" title="Month" name="date[month]" ref="select_month" @change="onDateChange">
            <option value="">Month</option>
            <option value="1" selected="selected">Jan</option>
            <option value="2">Feb</option>
            <option value="3">Mar</option>
            <option value="4">Apr</option>
            <option value="5">May</option>
            <option value="6">Jun</option>
            <option value="7">Jul</option>
            <option value="8">Aug</option>
            <option value="9">Sep</option>
            <option value="10">Oct</option>
            <option value="11">Nov</option>
            <option value="12">Dec</option>
          </select>

          <select v-show="checkLevel >= 1" class="form-select-year" title="Year" name="date[year]" ref="select_year" @change="onDateChange">
            <option value="" selected="selected">Year</option>
            <option v-for="index in 109" :key="index" :value="(yearNow - 109) + index">{{ (yearNow - 109) + index }}</option>
          </select>

           <span v-if="entranceForbidden" class="entrance-forbidden">Unfortunately you cannot enter Krug as you are not of legal drinking and purchasing age. You will be redirected to an informational website on responsible drinking.</span>
        </div>

        <div class="form-gold-checkbox">
					<label class="w-checkbox checkbox">
						<input type="checkbox" name="remember" value="1" class="form-checkbox" checked>
						<div class="gold-checkbox">
							<div class="gold-checkbox-check"></div>
						</div>
						<span class="checkbox-gold-label w-form-label"><span id="agegate-remember-text" class="agegate-remember-me-text">
              <div class="label-text">Remember me</div>
              </span>
            </span>
					</label>
				</div>

        <div class="age-remember-legal">Do not tick this box if your device is shared</div>

        <input data-wait="Please wait..." class="enter-button button" type="submit"  name="op" value="Enter">
        
        <div class="bottom-text">
          <p class="paragraph"> We support the consumption of wines and spirits through Moët Hennessy, a member of &nbsp;<a target="_blank" href="https://responsibledrinking.eu/">SpiritsEurope</a>, <a target="_blank" href="https://www.distilledspirits.org/">&nbsp;DISCUS</a> and &nbsp;<a target="_blank" href="https://www.ceev.eu/">CEEV</a>. By accessing this site you declare that you accept the&nbsp;<a target="_blank" href="https://www.krug.com/fr/mentions-legales">General Terms and Conditions of Use</a>&nbsp;and that you have read our&nbsp;<a target="_blank" href="https://www.krug.com/fr/charte-de-donnees-personelles-cookies">Personal Data &amp; Cookies policy.</a><br>Merci de ne pas partager ce site avec des personnes mineures.</p>

          <a href="https://info-calories-alcool.org/" target="_blank" class="infos-calories"><img class="logo-info-calories" svg-inline src="@/assets/images/common/logo-info-calorie-black.png" /></a>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import Cookies from 'js-cookie'

import data from '@/data' 

// there are 10 indexes in table

// 0 => country code
// 1 => country name
// 2 => age legal
// 3 => country is allowed
// 4 => date format à faire valider d'office : y, my, mdy, dmy, dmyt
// 5 => year format : defaut yyyy
// 6 => month start number : default 1
// 7 => day start number : default 1
// 8 => lang list
// 9 => default lang

import PlayerAutoVideoEmbed from '@/components/PlayerAutoVideoEmbed.vue'

export default {
  name: 'AgeGate',
  components: {
   PlayerAutoVideoEmbed
  },
  data () {
    const date = new Date()

    return {
      video: {
        "internalFile": true,
        "video_src_portrait": "assets/images/video/citronniers-mobile.mp4",
        "video_src_landscape": "assets/images/video/citronniers-desk.mp4"
      },

      // 1 = year, 2 = month, 3 = day
      checkLevel: 1,
      currentData: data.age_gate.GB.split('|'),
      legalAge: data.age_gate.GB.split('|')[2] && Number(data.age_gate.GB.split('|')[2]) || 18,
      allowedCountry: data.age_gate.GB.split('|')[3] === 'yes', 

      yearOk: false,
      monthOk: false,
      dayOk: false,

      dayNow: date.getDate(),
      monthNow: date.getMonth() + 1,
      yearNow: date.getFullYear(),

      entranceForbidden: false
    }
  },
  mounted () {
    this.onCountryChange()
  },
  methods:{
    onCountryChange (e) {
      const value = this.$refs.select_country.value?.toUpperCase()
      if (!data.age_gate[value]) return

      this.currentData = data.age_gate[value].split('|')
      this.legalAge = this.currentData[2] && Number(this.currentData[2]) || 18
      this.allowedCountry = this.currentData[3] === 'yes'

      this.setDefaultCheckLevel()
    },
    setDefaultCheckLevel () {
      const data_format = this.currentData[4]
      if (data_format === 'y') this.checkLevel = 1
      else this.checkLevel = 3
    },
    onDateChange () {
      this.setDefaultCheckLevel()

      this.checkYear()
      this.checkMonth()
      this.checkDay()
      
      console.log('')
      console.log('this.yearOk', this.yearOk)
      console.log('this.monthOk', this.monthOk)
      console.log('this.dayOk', this.dayOk)
    },
    onSubmit (e) {
      if (this.entranceForbidden) return

      this.setDefaultCheckLevel()

      this.checkYear()
      this.checkMonth()
      this.checkDay()
      
      console.log('')
      console.log('this.yearOk', this.yearOk)
      console.log('this.monthOk', this.monthOk)
      console.log('this.dayOk', this.dayOk)

      if (this.allowedCountry && this.yearOk && this.monthOk && this.dayOk) {
        Cookies.set('krug-age-gate', 'ok')
        window.location.reload()
      } else {
        this.entranceForbidden = true
        setTimeout(() => { window.location.href = 'https://www.wineinmoderation.eu/' }, 5000)
        
      }
    },
    checkDay () {
      this.dayOk = false

      if (this.checkLevel < 3) this.dayOk = true
      else {
        if (!this.$refs.select_day.value) return this.dayOk = false
        
        const day = Number(this.$refs.select_day.value)

        if (day < this.dayNow || day == this.dayNow) {
           // le jour de ses 18/21 ans est déjà passé ou est aujourd'hui
           this.dayOk = true
        }
      }
    },
    checkMonth () {
      this.monthOk = false

      if (this.checkLevel < 2) this.monthOk = true
      else {
        if (!this.$refs.select_month.value) return this.monthOk = false

        const month = Number(this.$refs.select_month.value)

        if (month == this.monthNow) {
          // on est au mois où il va avoir ses 18/21 ans, il faut vérifier si ils sont déjà passés ou non en fonction du jour
          this.monthOk = true
          this.checkLevel = this.checkLevel > 3 ? this.checkLevel : 3
        } else {
          // le mois de ses 18/21 ans est déjà passé
          if (month < this.monthNow) this.monthOk = true
        }
      }
    },
    checkYear () {
      this.yearOk = false

      if (this.checkLevel < 1) this.yearOk = true

      else {
        if (!this.$refs.select_year.value) return this.yearOk = false

        const year = Number(this.$refs.select_year.value)
        const userAge = this.yearNow - year

        if (userAge == this.legalAge) {
          // on est l'année de ses 18/21 ans, il faut vérifier si ils sont déjà passés ou non en fonction du mois
          this.yearOk = true
          this.checkLevel = this.checkLevel > 2 ? this.checkLevel : 2
        } else {
          // si il est plus vieux
          if (userAge > this.legalAge) this.yearOk = true
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .bloc-age-gate {
    width: 100vw;
    height: 100vh;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .bloc-age-gate__bg {
      width: 100vw;
      height: 100vh;
      position: absolute;
      filter: brightness(0.58);
    }

    .bloc-age-gate__popin {
      max-width: calc(100% - 40px);
      max-height: 90vh;
      overflow-y: auto;
      margin: 0 auto;
      background-image: url("~@/assets/images/icons/border.svg");
      padding: rem(20) rem(25);
      background-color: $th-cherry;
      background-size: rem(628) rem(125);
      background-position: rem(-37) rem(-4);
      z-index: 1;

      @include media($from: small) {
        max-width: rem(540);
      }

      .form {
        width: 100%;
        background: $th-white;
        padding: rem(30);
        text-align: center;

        @include media($from: small) {
          padding: rem(30) rem(56);
        }

        .logo {
          width: rem(110);
          margin: 0 auto;
          margin-bottom: rem(10);
          display: block;
        }

        .main-info {
          font-family: "EB Garamond Bold", serif;
          font-size: rem(20);
          line-height: rem(30);
          text-align: center;
          margin-bottom: rem(20);
          text-align: center;
          display: block;
        }

        .form-select-country {
          font-family: "EB Garamond Medium", serif;
          border: none;
          margin: 0 auto;
          color: $th-grey-2;
          display: block;
          border-bottom: 1px solid $th-grey-2;
          padding: rem(7) rem(20) rem(7) 0;
          font-size: rem(16);
          appearance: none;
          outline: none;
          border-radius: 0;
          max-width: 80%;
          cursor: pointer;
          background-image: url("~@/assets/images/icons/arrow-select.svg");
          background-position: right top 15px;
          background-repeat: no-repeat;
        }

        .selects-date {
          display: flex;
          margin-top: rem(30);
          margin-bottom: rem(42);
          justify-content: center;
          position: relative;
        }

        .form-select-day,
        .form-select-month,
        .form-select-year {
          font-family: "EB Garamond Medium", serif;
          border: none;
          outline: none;
          color: $th-grey-2;
          display: block;
          margin: 0 rem(10);
          border: 1px solid $th-grey-2;
          padding: rem(3) rem(5);
          font-size: rem(25);
          line-height: rem(55);
          appearance: none;
          border-radius: 0;
          cursor: pointer;
          text-align: center;
          min-width: rem(80);

          @include media($from: small) {
            font-size: rem(36);
            line-height: rem(60);
          }
        }

        .form-select-year {
          min-width: rem(134);
        }
        
        .entrance-forbidden {
          font-size: rem(11);
          line-height: 1;
          position: absolute;
          left: 0;
          bottom: -7px;
          text-align: center;
          display: block;
          width: 100%;
          transform: translateY(100%);
          color: red;
        }

        .form-gold-checkbox {
          margin-bottom: rem(13);
          display: inline-block;

          label {
            display: flex;
            align-items: center;
            justify-content: center;

            input {
              position: absolute;
              margin: 0;
              appearance: none;

              &:checked~.gold-checkbox>div {
                display: block;
              }
            }

            .gold-checkbox {
              position: relative;
              display: inline-block;
              border-style: solid;
              border-width: 1px;
              border-radius: 4px;
              cursor: pointer;
              margin: 0;
              width: 20px;
              height: 20px;
              border-color: #83786f;
              border-radius: 0;
              flex-shrink: 0;

              .gold-checkbox-check {
                top: 50%;
                left: 50%;
                transform: translate(-50%,-66%) rotate(45deg);
                width: 9px;
                height: 13px;
                position: absolute;
                display: none;
                border-style: solid;
                border-width: 0px 2px 2px 0px;
                border-color: $th-gold;
              }
            }

            .label-text {
              font-family: "Gotham Medium",sans-serif;
              font-size: rem(12);
              cursor: pointer;
              display: block;
              margin: 0;
              padding-left: 12px;
              text-transform: uppercase;
              padding-top: 1px;
            }
          }
        }

        .age-remember-legal {
          font-family: "EB Garamond",sans-serif;
          font-size: rem(12);
          line-height: rem(18);
          text-align: center;
        }

        .button {
          background-color: $th-cherry;
          color: $th-gold;
          font-family: "Gotham Medium",sans-serif;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0;
          line-height: 1;
          text-align: center;
          padding: 0 38px;
          margin: 20px auto 0;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-transform: uppercase;
          cursor: pointer;
          width: 80%;
          
           @include media($from: small) {
            width: auto;
          }
        }

        .bottom-text {
          font-family: "EB Garamond", serif;
          font-size: rem(12);
          line-height: rem(18);
          text-align: center;
          margin-top: rem(20);

          a {
            text-decoration: underline;
          }

          a.infos-calories {
            display: block;
            margin-top: rem(12);

            .logo-info-calories {
              width: rem(58);
              height: auto;
            }
          }          
        }
      }
    }
  }
</style>
